import React from "react";

const Experience = ({ lenguaje }) => {
  return (
    <div className="wrapper">
      <h1>{lenguaje == "eng" ? "EXPERIENCE" : "EXPERIENCIA"}</h1>
      <div className="experience">
        <section className="work">
          <article className="description">
            <small className="company">WorkSafe New Zealand</small>
            <h2>{lenguaje == "eng" ? "Web Developer" : "Desarrollador Web"}</h2>
            <p>
              {lenguaje == "eng"
                ? "This was a virtual collaboration with Auckland University of Technology students. Our goal was to build a web-app game to promote safety in workplaces."
                : "Esta fue una colaboración virtual con estudiantes de Auckland University of Technology. Nuestro objetivo fue construir un juego tipo web-app para promoter la seguridad en los lugares de trabajo."}
            </p>
          </article>
          <article className="details">
            <small className="work-date">
              {lenguaje == "eng"
                ? "March 2021 – November 2021"
                : "Marzo 2021 – Noviembre 2021"}
            </small>
            <small className="tools-used">CSS (SASS) – React – Node</small>
          </article>
        </section>
        <section className="work">
          <article className="description">
            <small className="company">
              {lenguaje == "eng"
                ? "University of La Frontera"
                : "Universidad de La Frontera"}
            </small>
            <h2>
              {lenguaje == "eng"
                ? "Research Assistant"
                : "Ayudante de Investigación"}
            </h2>
            <p>
              {lenguaje == "eng"
                ? "My role is to help with miscellaneous tasks in diverse areas of research, mainly related to computer science."
                : "Mi rol es ayudar con distintas tareas en diversas áreas de investigación, principalmente relacionadas con la informática."}
            </p>
          </article>
          <article className="details">
            <small className="work-date">
              {lenguaje == "eng" ? "Since March 2021" : "Desde Marzo 2021"}{" "}
            </small>
          </article>
        </section>
        <section className="work">
          <article className="description">
            <small className="company">
              {lenguaje == "eng"
                ? "University of La Frontera"
                : "Universidad de La Frontera"}
            </small>
            <h2>
              {lenguaje == "eng"
                ? "Math and Physics Tutor"
                : "Tutor Matemática y Física"}
            </h2>
            <p>
              {lenguaje == "eng"
                ? "Tutoring math to students and anyone who needs it, with a focus on Calculus and Algebra."
                : "Enseñando matemática y física a estudiantes y cualquiera que lo necesite. "}
            </p>
          </article>
          <article className="details">
            <small className="work-date">
              {lenguaje == "eng" ? "Since October 2020" : "Desde Octubre 2021"}
            </small>
          </article>
        </section>
      </div>
    </div>
  );
};

export default Experience;
